export const useSerializationUtils = () => {

  function queryStringFromParams(params) {
    return _buildQueryParams(params).join('&')
  }

  function _buildQueryParams(params, keyPath = null) {
    let isParamsValid = params == null || typeof params === 'object'
    if (!isParamsValid) throw new TypeError("`params` must be an object")

    let queryParams = []
    if (params == null) return queryParams

    for (let key in params) {
      let value = params[key]
      if (value == null) value = ''

      if (typeof value === 'object') {
        let fullKey = _fullKey(keyPath, key)
        queryParams.push(..._buildQueryParams(value, fullKey))
      }
      else queryParams.push(_serializeQueryStringValue(key, value, keyPath))
    }

    return queryParams
  }

  function _serializeQueryStringValue(key, value, keyPath = null) {
    let fullKey = _fullKey(keyPath, key)
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value)}`
  }

  function _fullKey(keyPath, key) {
    if (keyPath) return `${keyPath}[${key}]`
    else return key
  }

  return {
    queryStringFromParams
  }

}